import { NgModule } from '@angular/core';

import { BaseButtonDirective } from './base-button';
import { RtButtonVariant, RtInfoboxButtonVariant, RtPlanButtonVariant } from './button.types';
import { AddNewButtonComponent } from './components/add-new-button/add-new-button.component';
import { ButtonComponent } from './components/button/button.component';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { PlanButtonComponent } from './components/plan-button/plan-button.component';
import { ButtonDropdownIndicatorDirective } from './directives/button-dropdown/button-dropdown-indicator.directive';
import { ButtonLoadingDirective } from './directives/button-loading/button-loading.directive';

export const BUTTONS = [
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ButtonLoadingDirective,
  IconButtonComponent,
  PlanButtonComponent,
  AddNewButtonComponent,
];

/**
 *  @deprecated import required components or BUTTONS
 */
@NgModule({
  imports: BUTTONS,
  exports: BUTTONS,
})
export class ButtonModule {}
export {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ButtonLoadingDirective,
  IconButtonComponent,
  PlanButtonComponent,
  AddNewButtonComponent,
  BaseButtonDirective,
};

export { RtButtonVariant, RtInfoboxButtonVariant, RtPlanButtonVariant };
